import React from 'react'
import InnerHeaderPaySumamry from '../../components/comment/innerHeader/InnnerHeaderIcon'
import Footer from "../../components/footer";
import Header from "../../components/header/index";
import NetbankingContent from './netbankingcontent/netbankingContent';


const addnetbanking = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeaderPaySumamry title="Add net banking "/>
    <NetbankingContent />
    <Footer />
  </div>
  )
}

export default addnetbanking